export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '海量高清电影资源，涵盖动作、喜剧、科幻、爱情等多种类型',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热门国产剧、韩剧、美剧、日剧，每日更新最新剧集',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '最火爆的综艺节目，音乐、真人秀、脱口秀一网打尽',
  },
  {
    slug: 'duanshipin',
    name: '短视频',
    icon: 'ri-vidicon-line',
    description: '精彩短视频内容，搞笑、知识、生活、美食应有尽有',
  },
];

export const videos = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'dianying',
    categoryName: '电影',
    type: '科幻',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20spaceships%20in%20deep%20space%2C%20cinematic%20lighting%20with%20warm%20orange%20and%20gold%20accents%2C%20dark%20atmospheric%20background%2C%20high%20quality%20film%20poster%20style%2C%20dramatic%20composition&width=600&height=800&seq=video-01&orientation=portrait',
    year: 2025,
    duration: '148分钟',
    isVip: true,
    isHot: true,
  },
  {
    id: 2,
    title: '长安十二时辰',
    category: 'dianshiju',
    categoryName: '电视剧',
    type: '古装',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20poster%20with%20traditional%20costumes%20and%20palace%20architecture%2C%20warm%20golden%20lantern%20lighting%2C%20dark%20moody%20background%2C%20cinematic%20film%20poster%20style%2C%20elegant%20composition&width=600&height=800&seq=video-02&orientation=portrait',
    year: 2024,
    duration: '48集',
    isVip: true,
    isHot: true,
  },
  {
    id: 3,
    title: '极限挑战第十季',
    category: 'zongyi',
    categoryName: '综艺',
    type: '真人秀',
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Exciting%20variety%20show%20poster%20with%20dynamic%20group%20of%20celebrities%20in%20action%20poses%2C%20colorful%20vibrant%20lighting%20with%20warm%20tones%2C%20dark%20stage%20background%2C%20entertainment%20show%20poster%20style%2C%20energetic%20composition&width=600&height=800&seq=video-03&orientation=portrait',
    year: 2025,
    duration: '12期',
    isVip: false,
    isHot: true,
  },
  {
    id: 4,
    title: '人生大事',
    category: 'dianying',
    categoryName: '电影',
    type: '剧情',
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Emotional%20Chinese%20drama%20film%20poster%20with%20warm%20family%20scene%2C%20soft%20golden%20sunset%20lighting%2C%20touching%20atmosphere%2C%20cinematic%20movie%20poster%20style%2C%20intimate%20composition%20with%20human%20connection&width=600&height=800&seq=video-04&orientation=portrait',
    year: 2024,
    duration: '112分钟',
    isVip: false,
    isHot: false,
  },
  {
    id: 5,
    title: '狂飙',
    category: 'dianshiju',
    categoryName: '电视剧',
    type: '犯罪',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20drama%20poster%20with%20dark%20urban%20cityscape%20and%20silhouettes%2C%20dramatic%20noir%20lighting%20with%20red%20and%20gold%20accents%2C%20suspenseful%20atmosphere%2C%20high%20quality%20TV%20series%20poster&width=600&height=800&seq=video-05&orientation=portrait',
    year: 2023,
    duration: '39集',
    isVip: true,
    isHot: true,
  },
  {
    id: 6,
    title: '脱口秀大会第六季',
    category: 'zongyi',
    categoryName: '综艺',
    type: '脱口秀',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20comedian%20on%20stage%20under%20spotlight%2C%20warm%20stage%20lighting%20with%20golden%20tones%2C%20dark%20audience%20background%2C%20entertaining%20atmosphere%2C%20professional%20show%20poster%20style&width=600&height=800&seq=video-06&orientation=portrait',
    year: 2025,
    duration: '10期',
    isVip: false,
    isHot: false,
  },
  {
    id: 7,
    title: '封神第二部',
    category: 'dianying',
    categoryName: '电影',
    type: '奇幻',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20dark%20atmospheric%20sky%2C%20grandiose%20cinematic%20poster%20style%2C%20heroic%20composition&width=600&height=800&seq=video-07&orientation=portrait',
    year: 2025,
    duration: '156分钟',
    isVip: true,
    isHot: true,
  },
  {
    id: 8,
    title: '三体',
    category: 'dianshiju',
    categoryName: '电视剧',
    type: '科幻',
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20TV%20series%20poster%20with%20cosmic%20phenomena%20and%20three%20suns%20in%20the%20sky%2C%20cold%20atmospheric%20lighting%20with%20subtle%20warm%20accents%2C%20dark%20cosmic%20background%2C%20thought-provoking%20poster%20style&width=600&height=800&seq=video-08&orientation=portrait',
    year: 2024,
    duration: '30集',
    isVip: true,
    isHot: false,
  },
  {
    id: 9,
    title: '舌尖上的中国第四季',
    category: 'duanshipin',
    categoryName: '短视频',
    type: '美食',
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20poster%20with%20steaming%20hot%20traditional%20dishes%2C%20warm%20inviting%20kitchen%20lighting%20with%20rich%20golden%20tones%2C%20dark%20warm%20background%2C%20mouth-watering%20culinary%20photography%20style&width=600&height=800&seq=video-09&orientation=portrait',
    year: 2025,
    duration: '8集',
    isVip: false,
    isHot: false,
  },
  {
    id: 10,
    title: '满江红',
    category: 'dianying',
    categoryName: '电影',
    type: '历史',
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20film%20poster%20with%20ancient%20military%20setting%20and%20dramatic%20red%20banners%2C%20intense%20crimson%20and%20gold%20lighting%2C%20dark%20courtyard%20background%2C%20powerful%20cinematic%20poster%20style&width=600&height=800&seq=video-10&orientation=portrait',
    year: 2023,
    duration: '159分钟',
    isVip: false,
    isHot: false,
  },
  {
    id: 11,
    title: '奔跑吧第八季',
    category: 'zongyi',
    categoryName: '综艺',
    type: '真人秀',
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20variety%20show%20poster%20with%20celebrities%20running%20and%20laughing%20in%20nature%2C%20bright%20sunny%20lighting%20with%20warm%20tones%2C%20natural%20landscape%20background%2C%20fun%20energetic%20poster%20style&width=600&height=800&seq=video-11&orientation=portrait',
    year: 2025,
    duration: '12期',
    isVip: false,
    isHot: true,
  },
  {
    id: 12,
    title: '庆余年第二季',
    category: 'dianshiju',
    categoryName: '电视剧',
    type: '古装',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20fantasy%20drama%20poster%20with%20noble%20characters%20in%20luxurious%20costumes%2C%20warm%20palace%20lighting%20with%20golden%20accents%2C%20dark%20regal%20background%2C%20premium%20TV%20series%20poster%20style&width=600&height=800&seq=video-12&orientation=portrait',
    year: 2024,
    duration: '36集',
    isVip: true,
    isHot: true,
  },
];

export const videoCategories = ['dianying', 'dianshiju', 'zongyi', 'duanshipin'] as const;
export type VideoCategory = typeof videoCategories[number];